"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/button/style/index.js
// module id = 11
// module chunks = 1